import React, { useState, useEffect, useContext } from "react";
import Image from "next/legacy/image";
import defaultProfilePic from "@public/assets/images/blank-profile-picture.png";
import classes from "@styles/profile/upvoteFollowList.module.css";
import { getUpvotersList } from "@queries/community.queries";
import { Store } from "@store";
import InfiniteScroll from "react-infinite-scroll-component";
import LoadingCircle from "@components/loadings/LoadingCircle";
import Link from "next/link";
import { time_ago } from "@utils/metrics/timeFunction";
import { useRouter } from "next/router";
export default function UpvotersList({
  communityID
}) {
  const {
    state
  } = useContext(Store);
  const router = useRouter();
  const loggedInUser = state.user;
  const [list, setList] = useState([]);
  const [message, setMessage] = useState("");
  const [hasMore, setHasMore] = useState(true);
  useEffect(() => {
    async function getData() {
      const response = await getUpvotersList({
        communityID,
        accessToken: loggedInUser.accessToken
      });
      if (response.length > 0) {
        setList(response.map(({
          followerUid,
          ...User
        }) => {
          return {
            id: followerUid,
            data: {
              ...User
            }
          };
        }));
        setHasMore(true);
        //setIsLoading(false);
      } else {
        setMessage("No results");
        setHasMore(false);
      }
    }
    getData();
  }, [communityID, loggedInUser]);
  const updateData = async () => {
    const lastTs = list[list.length - 1].data.ts;
    const response = await getUpvotersList({
      communityID,
      accessToken: loggedInUser.accessToken,
      ts: lastTs
    });
    if (response.length > 0) {
      const array = response.map(({
        followerUid,
        ...User
      }) => {
        return {
          id: followerUid,
          data: {
            ...User
          }
        };
      });
      setList(cur => [...cur, ...array]);
      setHasMore(true);
    } else {
      setMessage("No results");
      setHasMore(false);
    }
  };
  function Row(cvalue, index) {
    return <Link scroll={false} href={`/profile/${cvalue.data.User.uid}`} rel="alternate" hrefLang={router.locale} passHref data-sentry-element="Link" data-sentry-component="Row" data-sentry-source-file="UpvotersList.jsx">
        <div key={index.toString()} className={classes.row}>
          <div style={{
          marginTop: "2px"
        }}>
            <Image src={cvalue.data.User?.dp || defaultProfilePic} alt={`${cvalue.data.User.name} dp`} width="60" height="60" objectFit="cover" style={{
            borderRadius: "50%"
          }} data-sentry-element="Image" data-sentry-source-file="UpvotersList.jsx" />
          </div>
          {/* <p>{cvalue.data.User.name}</p> */}
          <div className={classes.p_small}>
            <p>{cvalue.data.User.name}</p>
            <small suppressHydrationWarning={true}>
              {time_ago(cvalue.data.ts)}
            </small>
          </div>
        </div>
      </Link>;
  }
  return <>
      <div id={classes.list} className={classes.list}>
        {list.length > 0 ? <InfiniteScroll dataLength={list.length} next={updateData} hasMore={hasMore} loader={<LoadingCircle />} scrollableTarget={classes.list} endMessage={<p className={classes.endMessage}>{message}</p>}>
            {list.map(Row)}
          </InfiniteScroll> : <p className={classes.noUpvotesText}>No upvotes yet.</p>}
      </div>
    </>;
}